
import {QBtn, QRating} from "quasar"
import RetirementAdequacyChart from "@/superannuation/RetirementAdequacyChart.vue"
import Vue from "vue"
import Component from "vue-class-component"
import {Inject} from "vue-property-decorator"
import {PlanSuperScoreService} from "@/superscore/PlanSuperScoreService"
import OverTimeChart from "@/superannuation/OverTimeChart.vue"
import MetricTrendWidget from "@/superannuation/MetricTrendWidget.vue"
import BeneficiaryNominationChart from "@/superannuation/BeneficiaryNominationChart.vue"
import SuperScoreStar from "@avantek/commons-js/superscore/SuperScoreStar/SuperScoreStar.vue"
import ChangeRateWidget from "@/superannuation/ChangeRateWidget.vue"
import {PlanService} from "@/superannuation/PlanService"
import DateRangeSelect from "@/superannuation/DateRangeSelect.vue"
import PlanSuperScoreWidget from "@/superscore/PlanSuperScoreWidget.vue"
import {SuperScoreArea} from "@/superscore/SuperScoreArea"
import News from "@/news/NewsWidget.vue"
import {NewsService} from "@/news/NewsService"
import SuperScoreComponentWidget from "@/components/dashboard/SuperScoreComponentWidget.vue"
import {MetricStore} from "@/cube/metric-data/MetricStore"
import {DateRangeService} from "@/DateRangeService"
import CircularProgressBarWidget from "@/components/CircularProgressBarWidget/CircularProgressBarWidget.vue"
import CampaignTable from "@/components/CampaignTable/CampaignTable.vue"
import ProgressBar from "@/components/ProgressBar/ProgressBar.vue"
import PageHeader from "@/superannuation/PageHeader.vue"
import CircularProgressWidget from "@/components/dashboard/CircularProgressWidget.vue"
import BuiltWithAmcharts from "@/BuiltWithAmcharts.vue"
import axios from "axios"
import {AuthenticationService} from "@/AuthenticationService"

@Component({
  // name is necessary for keep-alive to work in production mode
  name: "DashboardView",
  components: {
    BuiltWithAmcharts,
    PlanSuperScoreWidget,
    SuperScoreComponentWidget,
    BeneficiaryNominationChart,
    QBtn,
    QRating,
    RetirementAdequacyChart,
    OverTimeChart,
    MetricTrendWidget,
    ChangeRateWidget,
    SuperScoreStar: <any>SuperScoreStar,
    DateRangeSelect,
    News,
    CircularProgressBarWidget,
    CircularProgressWidget,
    CampaignTable,
    ProgressBar,
    PageHeader,
  },
})
export default class DashboardView extends Vue {
  @Inject()
  planSuperScoreService: PlanSuperScoreService

  @Inject()
  planService: PlanService

  @Inject()
  newsService: NewsService

  @Inject()
  dateRangeService: DateRangeService

  @Inject()
  authenticationService: AuthenticationService

  SuperScoreArea = SuperScoreArea

  metricStore: MetricStore | null = null

  unwatchDateRange?: () => void

  pageReady: boolean | null = null

  policyCommitteeInProgress = false
  analyticsDataInProgress = false

  isStaff = false

  // Tracks how many rows each CampaignTable loaded (-1 = not yet loaded,
  // 0 = empty, N = has data). Cards with 0 rows are hidden in the template.
  campaignTableCounts = {report: -1, email: -1, welcome: -1}

  async created() {
    this.isStaff = await this.authenticationService.isStaff()
    this.metricStore = new MetricStore(this.planService.engagedOnly)

    this.$watch(
      () => this.planService.current?.id,
      async () => {
        await this.dateRangeService.setPlan(this.planService.current!.id)
        if (this.dateRangeService.dateRangeSelector?.selected !== undefined) {
          this.metricStore!.update(
            this.planService.current!.id,
            this.dateRangeService.dateRangeSelector.selected
          ).catch(() => console.log("Plan switch failed"))
        }
      }
    )

    const unwatchPlan = this.$watch(
      () => this.planService.current,
      async plan => {
        if (plan != null) {
          await this.dateRangeService.setPlan(plan.id)
          unwatchPlan()
          this.unwatchDateRange = this.watchDateRange()
        }
      },
      {immediate: true}
    )

    this.$watch(
      () => this.planService.engagedOnly,
      async () => {
        await this.metricStore!.setEngagedOnly(this.planService.engagedOnly)
      }
    )

    this.$watch(
      () => this.metricStore!.isUpdating(),
      async updating => (this.pageReady = !updating)
    )
  }

  downloadSingleFlyer() {
    if (this.planService.current?.files.length === 1) {
      void this.planService.getFlyer(this.formatFlyerFileNames()![0])
    }
  }

  formatFlyerFileNames() {
    return this.planService.current?.files.map(name => name.replace(".pdf", "")) ?? []
  }

  async downloadPlanData() {
    this.analyticsDataInProgress = true

    await this.planService.getData()

    this.analyticsDataInProgress = false
  }

  async requestPcmReport() {
    console.log("requesting report")
    this.policyCommitteeInProgress = true

    const report = await axios.post(
      "/pcm/",
      {
        data: {
          currentPlan: this.planService.getPlanFromSessionStorage(),
        },
      },
      {responseType: "blob"}
    )
    console.log(report)
    const url = window.URL.createObjectURL(new Blob([report.data]))
    const link = document.createElement("a")
    link.href = url
    link.setAttribute("download", `pcmreport.pdf`)
    document.body.append(link)
    link.click()
    link.remove()

    this.policyCommitteeInProgress = false
  }

  deactivated() {
    this.unwatchDateRange?.()
  }

  private watchDateRange() {
    return this.$watch(
      () => this.dateRangeService.dateRangeSelector?.selected,
      async dateRange => {
        if (dateRange != null && this.metricStore != null) {
          await this.metricStore!.update(this.planService.current!.id, dateRange)
        }
      },
      {immediate: true}
    )
  }

  private openPolicyCommitteeReport() {
    const url = `/playwright/pcr/pdf/${this.planService.current!.id}`
    window.open(url, "_blank")
  }
}
